<script>
  import { createEventDispatcher } from "svelte"
  const dispatch = createEventDispatcher()
</script>

<div class="fixed inset-0 z-50 !mt-0 flex items-center justify-center overflow-hidden bg-[#000000cc] backdrop-blur-md">
  <div class="relative m-6 flex w-[700px] transform select-none flex-col items-center rounded-md bg-white transition-all dark:bg-bodyblack md:m-0">
    <div class="flex w-full items-center justify-center rounded-md bg-white p-3 text-black dark:bg-bodyblack md:p-6">
      <h1 class="text-xl font-bold text-black dark:text-white lg:text-2xl xl:text-2xl">Confirmation for marking emails as sent</h1>
    </div>

    <div class="w-3/4 break-words p-6 text-center text-gray-400">
      Are you sure you want to mark the emails in this session as sent? You can revert this action later using the <strong>Enable Resend</strong>
      option.
    </div>

    <div class="flex flex-row items-center justify-center gap-3 rounded-md bg-white p-2 dark:bg-bodyblack sm:flex md:gap-0 md:p-4">
      <button on:click type="button" class="flex h-9 min-h-full min-w-[36px] items-center justify-center rounded-md border border-[#a0a1a580] bg-[#f7f7f7] px-3 py-1.5 text-sm font-medium text-gray-900 hover:bg-red-500 hover:text-white focus:outline-none dark:bg-lightgray dark:text-white dark:hover:bg-red-500 sm:ml-3 sm:w-auto">
        <span>
          <i class="fa-solid fa-circle-xmark" />
        </span>
        <span class="select-none">&nbsp;&nbsp;Cancel&nbsp;&nbsp;</span>
      </button>
      <button
        on:click={() => {
          dispatch("remove")
        }}
        type="button"
        class="flex h-9 min-h-full min-w-[36px] items-center justify-center rounded-md border border-[#a0a1a580] bg-[#f7f7f7] px-3 py-1.5 text-sm font-medium text-gray-900 hover:bg-green-500 hover:text-white focus:outline-none dark:bg-lightgray dark:text-white dark:hover:bg-green-500 sm:ml-3 sm:w-auto"
      >
        <span>
          <i class="fa-solid fa-circle-check" />
        </span>
        <span class="select-none">&nbsp;&nbsp;Mark&nbsp;as&nbsp;sent&nbsp;</span>
      </button>
    </div>
  </div>
</div>
